import type {paths} from '../../openapi';
import {axiosInstance} from '../axiosInstance';

type HideBannerOperation = paths['/executor_web/banners/{id}']['delete'];

export type HideBannerPath = HideBannerOperation['parameters']['path'];

/** DELETE `/executor_web/banners/{id}` — скрыть баннер */
export function hideBanner(path: HideBannerPath) {
	return axiosInstance.delete(`banners/${path.id}`);
}
